import map from 'lodash/map';

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import * as store from 'store';

import { RANDOMIZATION_HYPOTHESIS_TESTING_FORM } from 'store/form';

import {
  getSamplesMean, getSamplesStdev
} from 'store/scenes/randomizationHypothesisTesting/samples/selectors';

import { getAlpha } from 'store/form/randomizationHypothesisTesting/selectors';

import RightPaneComponent from './Component';
import { getPrimaryParameter } from 'store/scenes/randomizationHypothesisTesting/primaryParameter/selectors';
import { getSecondaryParameter } from 'store/scenes/randomizationHypothesisTesting/secondaryParameter/selectors';
import { getPrimaryParameterLevel } from 'store/scenes/randomizationHypothesisTesting/primaryParameterLevel/selectors';

class RightPaneContainer extends React.PureComponent {
  constructor (props) {
    super(props);

    this.handleDotClick = ({ target: { __data__: { id } } }) =>
      this.props.setSelectedSampleId(id);
  }

  get tailTypeRadioButtonProps () {
    return {
      getAlpha,

      form: RANDOMIZATION_HYPOTHESIS_TESTING_FORM,

      mean: this.props.mean,
      stdev: this.props.stdev
    };
  }

  render () {
    const { values, tailType } = this.props;

    const dots = map(values, (value, index) =>
      ({ id: index, value })
    );

    return (
      <RightPaneComponent
        mean={this.props.mean}
        stdev={this.props.stdev}
        amount={this.props.amount}

        dots={dots}

        testSelection={this.props.testSelection}
        simulatedPLineX={this.props.simulatedPLineX}
        selectedSampleId={this.props.selectedSampleId}
        tailTypeRadioButtonProps={this.tailTypeRadioButtonProps}
        measurement={this.props.measurement}

        leftCutoff={
          tailType === 'left' || tailType === 'both'
            ? this.props.leftCutoff
            : -Infinity
        }

        rightCutoff={
          tailType === 'right' || tailType === 'both'
            ? this.props.rightCutoff
            : +Infinity
        }

        onDotClick={this.handleDotClick}
      />
    );
  }
}

RightPaneContainer.propTypes = {
  values: PropTypes.arrayOf(
    PropTypes.number.isRequired
  ).isRequired,

  mean: PropTypes.number.isRequired,
  stdev: PropTypes.number.isRequired,
  amount: PropTypes.number.isRequired,

  tailType: PropTypes.string.isRequired,

  leftCutoff: PropTypes.number.isRequired,
  rightCutoff: PropTypes.number.isRequired,

  simulatedPLineX: PropTypes.number.isRequired,

  selectedSampleId: PropTypes.number.isRequired,
  setSelectedSampleId: PropTypes.func.isRequired,

  testSelection: PropTypes.string.isRequired,
  measurement: PropTypes.string.isRequired
};

const {
  scenes: {
    randomizationHypothesisTesting: {
      samples: {
        getValues,
        getSamplesAmount,
        getSimulatedPLineX
      },

      selectedSampleId: {
        getSelectedSampleId,
        setSelectedSampleId
      },

      testSelection: {
        getCapitalizedTestSelection
      }
    }
  },

  form: {
    randomizationHypothesisTesting: {
      getTailType,

      getLeftCutoff,
      getRightCutoff
    }
  }
} = store;

const mapStateToProps = state => {
  let measurement = getPrimaryParameter(state).name;
  if (getSecondaryParameter(state).name.length > 0) {
    measurement = (`(${getPrimaryParameter(state).name}~${getSecondaryParameter(state).name})`);
  } else if (getPrimaryParameterLevel(state).length > 0) {
    measurement = (`(${getPrimaryParameter(state).name} = '${getPrimaryParameterLevel(state)}')`);
  }

  return {
    mean: getSamplesMean(state),
    stdev: getSamplesStdev(state),

    values: getValues(state),

    amount: getSamplesAmount(state),

    tailType: getTailType(state),

    leftCutoff: getLeftCutoff(state) || -Infinity,
    rightCutoff: getRightCutoff(state) || +Infinity,

    simulatedPLineX: getSimulatedPLineX(state),
    selectedSampleId: getSelectedSampleId(state),

    testSelection: getCapitalizedTestSelection(state),
    measurement
  };
};

const mapDispatchToProps = {
  setSelectedSampleId
};

export default reduxForm({
  destroyOnUnmount: false,
  form: RANDOMIZATION_HYPOTHESIS_TESTING_FORM
})(connect(mapStateToProps, mapDispatchToProps)(
  RightPaneContainer
));
